module.exports = __webpack_public_path__ + "img/prostoj-start.07ba80de.png";